module.exports = __webpack_public_path__ + "img/xmasParty15.ef1590e7.jpg";